




























































import Vue from 'vue'
import inputsMixin from '@/mixins/inputs-mixin'
export default Vue.extend({
    mixins: [inputsMixin],
    props: {
        //  The color theme of the component
        color: {
            type: String,
            default: 'primary'
        },
        //  Determines if a divider is shown between the tabs and the content
        divider: {
            type: Boolean,
            default: false
        },
        //  Applies the compact style (ie smaller tabs)
        compact: {
            type: Boolean,
            default: false
        },
        //  Determines how we justify the tab icons
        justify: {
            type: String,
            default: 'center'
        },
        //  Determines if we use default width or content width
        min: {
            type: Boolean,
            default: false
        },
        //  The text displayed below the title
        subtitle: {
            type: String,
            default: null
        },
        //  The tabs displayed in the tab panel
        tabs: {
            type: Array,
            required: true
        },
        //  The title displayed above the tabs
        title: {
            type: String,
            default: null
        },
        //  The style to apply to our title
        titleStyle: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            activeIndex: 0
        }
    },
    computed: {
        step(): number {
            return this.activeIndex + 1
        },
        styleRightTools(): object {
            return {
                position: 'absolute',
                height: '60px',
                right: '0px',
                margin: this.$vuetify.breakpoint.xsOnly ? '0px' : '0px 20px 0px 0px'
            }
        },
        styleLeftTools(): object {
            return {
                position: 'absolute',
                height: '60px',
                left: '0px',
                margin: this.$vuetify.breakpoint.xsOnly ? '0px' : '0px 0px 0px 20px'
            }
        }
    },
    methods: {
        tabChange(index: number): void {
            //  If the destination is different from the current route
            this.activeIndex = index
            //  Emit to the parent
            this.$emit('change', index)
        }
    }
})
